(function () {
	'use strict';

	const speakerContainer = document.querySelector('#tuw-speaker');
	const backgroundText = speakerContainer ? speakerContainer.querySelector('.background-text') : null;

	// move background text outside
	if ( speakerContainer && backgroundText ) {
		speakerContainer.prepend(backgroundText);
	}

	// nav overlay on mobile
	const navToggle = document.querySelector('#NavToggle');
	const nav = document.querySelector('#Nav');

	navToggle.addEventListener('click', () => {
		navToggle.classList.toggle('close');
		nav.classList.toggle('open');
	});

	nav.querySelectorAll('a').forEach(link => link.addEventListener('click', (e) => {
		navToggle.classList.remove('close');
		nav.classList.remove('open');
	}))

	// AJAX Newslist loading
	const newslistLoading = () => {
		document.querySelectorAll('.mod_newslist[data-ajax-reload-element]').forEach((newslist) => {
			// Amount change
			newslist.querySelectorAll('select[name="news-amount-options"]').forEach((select) => {
				select.addEventListener('change', () => {
					newslist.classList.add('loading');
					const xhr = new XMLHttpRequest();
					xhr.open('POST', select.value);
					xhr.responseType = 'json';
					xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
					xhr.onload = function() {
						if (xhr.status !== 200 || typeof xhr.response.status === 'undefined' || 'ok' !== xhr.response.status) {
							return;
						}
	
						newslist.outerHTML = xhr.response.html;
						newslistLoading();
					};
					xhr.onerror = function() {};
					xhr.onloadend = function() {
						newslist.classList.remove('loading');
					};
					xhr.send('ajax_reload_element='+newslist.dataset.ajaxReloadElement);
				});
			});	

			// Load more
			newslist.querySelectorAll('.pagination .next a').forEach((link) => {
				link.addEventListener('click', (event) => {
					event.preventDefault();
					newslist.classList.add('loading');
					const xhr = new XMLHttpRequest();
					xhr.open('POST', link.href);
					xhr.responseType = 'json';
					xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
					xhr.onload = function() {
						if (xhr.status !== 200 || typeof xhr.response.status === 'undefined' || 'ok' !== xhr.response.status) {
							return;
						}

						const pagination = newslist.querySelector('.pagination');
						const temp = document.createElement('div');
						temp.innerHTML = xhr.response.html;

						temp.querySelectorAll('.layout_latest').forEach((item) => {
							newslist.insertBefore(item, pagination);
						});

						const newLink = temp.querySelector('.pagination .next a');

						if (newLink) {
							link.href = newLink.href;
							link.title = newLink.title;
						} else {
							pagination.style.display = 'none';
						}
					};
					xhr.onerror = function() {};
					xhr.onloadend = function() {
						newslist.classList.remove('loading');
					};
					xhr.send('ajax_reload_element='+newslist.dataset.ajaxReloadElement);
					return false;
				});
			});
		});
	};

	newslistLoading();
})();
